import {
  clearSrDocumentDocTypeAction,
  deleteSrDocumentDocType,
} from 'actions/srDocuments/srDocumentDocTypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentDocTypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentDocTypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentDocType(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site readiness document file type?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentDocTypeDelete
